import React, { Component, useState, useEffect } from "react";
import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";
import {
  TypeOfJob,
  NameAndPhoneNo,
  UploadYourImages,
  jobsListStore,
} from "../JoinUs/index";

import styles from "./css/Project.module.css";

const renovationGoalsStore = [
  {
    urlTxt: "sell",
    hrefTxt: "Sell",
  },
  {
    urlTxt: "to_leave",
    hrefTxt: "To Leave",
  },
  {
    urlTxt: "rental",
    hrefTxt: "Rental",
  },
];

export class Project extends Component {
  render() {
    return (
      <div className={styles.joinUs}>
        <div className={styles.joinUsInner}>
          <Navbar></Navbar>
          <div className={styles.bodyBlock}>
            <div className={styles.bodyBlockInner}>
              <div className={styles.userInformationInputBlock}>
                <ModalToCollectUserData></ModalToCollectUserData>
              </div>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </div>
    );
  }
}

const ModalToCollectUserData = (props) => {
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [previousUploadedImages, setPreviosUploadedImages] = useState([]);
  const [myJob, setMyJob] = useState(null);
  const [jobsList, setJobsList] = useState([]);
  const [renovationGoals, setRenovationGoals] = useState([]);
  const [myRenovationGoal, setMyRenovationGoal] = useState(false);

  useEffect(() => {
    setPreviosUploadedImages([]);
    setMyJob(jobsListStore[0]);
    setJobsList(jobsListStore);
    setRenovationGoals(renovationGoalsStore);
    setMyRenovationGoal(renovationGoalsStore[0]);
  }, [props]);

  const nextMove = () => {
    if (currentModalIndex < 4) {
      setCurrentModalIndex((currentModalIndex) => currentModalIndex + 1);
    }
  };

  const prevMove = () => {
    if (currentModalIndex > 0) {
      setCurrentModalIndex((currentModalIndex) => currentModalIndex - 1);
    }
  };

  const selectJob = (job) => {
    setMyJob(job);
  };

  const selectRenovationGoal = (goal) => {
    setMyRenovationGoal(goal);
  };

  return (
    <div className={styles.modalCont}>
      <div className={styles.modalBody}>
        <SwitchModalScreen
          currentModalIndex={currentModalIndex}
          previousUploadedImages={previousUploadedImages}
          myJob={myJob}
          renovationGoals={renovationGoals}
          myRenovationGoal={myRenovationGoal}
          jobsList={jobsList}
          selectJob={selectJob}
          setMyRenovationGoal={selectRenovationGoal}
        ></SwitchModalScreen>
      </div>
      <div className={styles.actionBtns}>
          {
              currentModalIndex==0?
              null:
            <button className={styles.prevBtn} onClick={() => prevMove()}>
              Previous
            </button>
          }

        <button className={styles.nextBtn} onClick={() => nextMove()}>
          Next
        </button>
      </div>
    </div>
  );
};

const SwitchModalScreen = (props) => {
  if (props.currentModalIndex == 0) {
    return (
      <TypeOfJob
        jobsList={props.jobsList}
        myJob={props.myJob}
        selectJob={props.selectJob}
      ></TypeOfJob>
    );
  } else if (props.currentModalIndex == 1) {
    return (
      <GoalForRenovation
        renovationGoals={props.renovationGoals}
        myRenovationGoal={props.myRenovationGoal}
        setMyRenovationGoal={props.setMyRenovationGoal}
      ></GoalForRenovation>
    );
  } else if (props.currentModalIndex == 2) {
    return (
      <UploadYourImages
        previousUploadedImages={props.previousUploadedImages}
      ></UploadYourImages>
    );
  } else if (props.currentModalIndex == 3) {
    return <ProjectAddress></ProjectAddress>;
  } else if (props.currentModalIndex == 4) {
    return <NameAndPhoneNo></NameAndPhoneNo>;
  }
};

const GoalForRenovation = (props) => {
  const setGoalForRenovation = (goal) => {
    props.setMyRenovationGoal(goal);
  };
  return (
    props.myRenovationGoal?
    <div>
      <div className={styles.modalHeading}>
        <h3>Your goal for this renovation</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.jobsList}>
          {props.renovationGoals
            ? props.renovationGoals.map((goal, index) => (
                <div
                  key={index}
                  className={styles.singleJob}
                  onClick={() => setGoalForRenovation(goal)}
                >
                  <div className={styles.radioBtnCont}>
                    {props.myRenovationGoal["urlTxt"] == goal["urlTxt"] ? (
                      <div className={styles.radioBtn}></div>
                    ) : null}
                  </div>
                  <div>{goal["hrefTxt"]}</div>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>:
    null
  );
};

const ProjectAddress = (props) => {
  return (
    <div>
      <div className={styles.modalHeading}>
        <h3>What's your project address?</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>Address</label>
          </div>
          <div className={styles.input}>
            <input type="text" placeholder="Address" />
          </div>
        </div>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>City</label>
          </div>
          <div className={styles.input}>
            <input type="text" placeholder="Select City" />
          </div>
        </div>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>ZIP Code</label>
          </div>
          <div className={styles.input}>
            <input type="number" placeholder="Your project ZIP Code" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
